// extracted by mini-css-extract-plugin
export default {"userCard":"UserCard_userCard__gW4J3","userAvatar":"UserCard_userAvatar__QZDus","userName":"UserCard_userName__qseLz"};